import { Link, useSearchParams } from 'react-router';
import Alert from '../../components/Alert';

export default function UrlTriggeredAlert() {
    const [searchParams] = useSearchParams();

    const ref = searchParams.get('ref');

    if (!ref) return null;

    if (ref === 'approved') {
        return (
            <Alert type="success">
                <p>
                    Uživatel byl úspěšně ověřen.
                </p>
            </Alert>
        );
    }

    if (ref === 'rejected') {
        return (
            <Alert type="error">
                <p>Uživatel byl odmítnut.</p>
            </Alert>
        );
    }

    return null;
}
